<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.request')}} #{{sender.displayId}}
                    </label>
                </div>
                <div class="col-auto" v-if="!isCstReadOnly">
                    <router-link v-if="(userRole == 2 ||userRole == 5) && sender.requestStatus == 3 && !sender.automaticallyInserted" :to="isFromDashboard? '/ConnectingRequestDashboard/UpdateContractRequest/' + id : '/ConnectingRequestDashboard/RenewContractRequest/' + id" tag="button" class="btn btn-success px-4">{{$t('shared.edit')}}</router-link>
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on }">
                            <v-btn color="btn-primary"
                                   v-on="on">
                                <div>{{$t('shared.actionHere')}}</div>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile v-if="(userRole == 1  || userRole == 9 || userRole == 15 ) && sender.requestStatus == '1' && !sender.automaticallyInserted && ((userRole == 1 && sender.tenantId == tenantId) || userRole != 1) " @click="showapproveDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="((userRole == 2 ||userRole == 5) && !providerLocked) && !sender.automaticallyInserted && sender.requestStatus == 3 && !sender.automaticallyInserted" @click="showresendDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.resend')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="(userRole == 1  || userRole == 9 || userRole == 15 ) && ((userRole == 1 && sender.tenantId == tenantId) || userRole != 1) && !sender.automaticallyInserted && sender.requestStatus == '1'" @click="showRejectDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="(userRole == 2 ||userRole == 5)&& sender.requestStatus == 4 && sender.senderStatus == 7" @click="ConectivityDetail(sender.senderId)">
                                <v-list-tile-title class="white">{{$t('dashboardPage.ConnectivityDetail')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showSenderRequestTransactions()">
                                <v-list-tile-title class="white">{{$t('shared.showSenderRequestActions')}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.senderName')}}</label>
                                    <h4 class="user_info_txt">{{sender.senderName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                                    <h4 class="user_info_txt">
                                        <span v-for="(type, index) in senderType" :key="type">
                                            {{getSenderTypeText(type)}}
                                        </span>
                                    </h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.expiryDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.expiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderExpiryDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.senderExpiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                                    <h4 class="user_info_txt">{{sender.clientName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType !== 3">
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                    <h4 class="user_info_txt">{{sender.crNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType === 2 ||sender.customerType === 3">
                                    <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                    <h4 class="user_info_txt">{{sender.enterpriseUnifiedNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                                    <h4 class="user_info_txt">{{getCustomerTypeText(sender.customerType)}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.requestType')}}</label>
                                    <h4 class="user_info_txt">{{getRequestTypeText(sender.requestType) }}</h4>
                                </div>

                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.representativeName')}}</label>
                                    <h4 class="user_info_txt">{{maskedRepresentativeName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.representativeEmail')}}</label>
                                    <h4 class="user_info_txt">{{sender.representativeEmail}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.representativeMobile')}}</label>
                                    <h4 class="user_info_txt">{{sender.representativeMobile}}</h4>
                                </div>

                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header">{{$t('shared.attachContract')}}</label>
                                    <h4 class="user_info_txt">
                                        <span @click="DownloadFile(sender.contractAttachment)" class="badge badge-primary">
                                            <i class="fas fa-paperclip"></i>{{sender.contractAttachment.fileName}}
                                            <i class="fas fa-arrow-down"></i>
                                        </span>
                                    </h4>
                                </div>
                                <div class="col-md-12" v-if="sender.requestStatus == 3">
                                    <label class="user_info_header mb-3">{{$t('shared.rejectionReason')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.lastRejectionReason" readonly></textarea>
                                </div>
                                <div class="col-md-12" v-if="(sender.requestStatus == 1 || sender.requestStatus == 10) && sender.comment && sender.comment.trim() && (sender.requestStatus != 1 || !sender.automaticallyInserted)">
                                    <label class="user_info_header mb-3">{{$t('shared.comment')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.comment" readonly></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <Progress :transitionDuration="1000" :radius="85" :strokeColor="checkColor(sender.requestStatus)" :strokeWidth="10" :value="getRate(sender.startDate, sender.duration)">
                                <div class="content">
                                    <label class="w-100" :class="'status-' + sender.requestStatus">{{GetSenderStatus(sender.requestStatus)}}</label>
                                    <p>
                                        {{sender.remainingDays}} {{$t('dashboardPage.of')}} {{sender.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                    </p>
                                </div>
                            </Progress>
                        </div>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/ConnectingRequestDashboard" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="showSenderRequestTransactionsdialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.SenderRequestActionsInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideshowSenderRequestTransactionsdialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <template>
                        <v-data-table :headers="headers"
                                      :items="SenderRequestTransactions"
                                      hide-actions
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.requestStatus }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">{{ props.item.comment }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

    <div class="text-xs-center">
        <v-dialog v-model="resendDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.resendInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideresendDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="resendComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.resendInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideresendDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="resend('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.approveInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <reject-reason-multi-select
                                :items="popUpRejectionReasons"
                                :value="selectedRejectReasons"
                                :other-text="otherRejectReasonText"
                                :disabled="rejectReasonsLocked"
                                @input="onRejectReasonsChanged"
                                @other-text="onOtherRejectTextChanged">
                            </reject-reason-multi-select>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <!--<div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.rejectreason')}}</label>
                                <input class="form-control" v-model="rejectResone" type="text" />
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>-->
</div>

